export interface IEmvData {
    readonly AID?: string;
    readonly IAD?: string;
    readonly TSI?: string;
    readonly TVR?: string;
}
  
export interface IReceiptData {
    readonly address1?: string;
    readonly address2?: string;
    readonly dateTime?: string;
    readonly dba?: string;
    readonly footer?: string;
    readonly header?: string;
    readonly nameOnCard?: string;
    readonly phone?: string;
}
  
export interface IReceiptObjectData extends IReceiptData {
    readonly Signature?: string;
    readonly Mode?: string;
    readonly 'Network Label'?: string;
    readonly 'Entry method'?: string;
    readonly 'Application Label'?: string;
    readonly emv?: IEmvData;
    readonly PIN?: string;
}
  
export class EmvData implements IEmvData {
    AID?: string;
    IAD?: string;
    TSI?: string;
    TVR?: string;
  
    constructor(data: IEmvData) {
      Object.assign(this, data);
    }

    toJSON(): IEmvData {
      return { ...this };
    }
}
  
export class ReceiptData implements IReceiptData {
    address1?: string;
    address2?: string;
    dateTime?: string;
    dba?: string;
    footer?: string;
    header?: string;
    nameOnCard?: string;
    phone?: string;
  
    constructor(data: IReceiptData) {
      Object.assign(this, data);
    }

    toJSON(): IReceiptData {
      return { ...this };
    }
}
  
export class ReceiptObjectData extends ReceiptData implements IReceiptObjectData {
    Signature?: string;
    Mode?: string;
    'Network Label'?: string;
    'Entry method'?: string;
    'Application Label'?: string;
    emv?: EmvData;
    PIN?: string;
  
    constructor(data: IReceiptObjectData) {
      super(data);
      if (data.emv) {
        this.emv = new EmvData(data.emv);
      }
    }

    toJSON(): IReceiptObjectData {
      const json: any = {
        ...super.toJSON(),
        Signature: this.Signature,
        Mode: this.Mode,
        'Network Label': this['Network Label'],
        'Entry method': this['Entry method'],
        'Application Label': this['Application Label'],
        PIN: this.PIN,
      };
      if (this.emv) {
        json.emv = this.emv.toJSON();
      }
      return json as IReceiptObjectData;
    }
} 